<script>
export default {
  props: {
    icon: String,
    title: String,
    type: String,
  },
};
</script>

<template>
  <f-hint-base :type="type">
    <div class="f-hint-content">
      <div class="icon" v-if="icon">
        <f-icon :icon="icon"></f-icon>
      </div>
      <div class="f-hint-content-content">
        <div class="title" v-if="$slots.title">
          <slot name="title"></slot>
        </div>
        <div class="text">
          <slot name="message"></slot>
        </div>
      </div>
      <div class="separator"></div>
      <div class="action" v-if="$slots.action">
        <slot name="action"></slot>
      </div>
    </div>
  </f-hint-base>
</template>

<style lang="scss">
.f-hint {
  .f-hint-content {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    gap: 8px;

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      width: 30px;
      color: var(--turquoise);
	  padding:4px;
    }

    .f-hint-content-content {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .title {
        font-weight: bold;
        font-family: "Lato";
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #161615;
      }

      .text {
        font-family: "Lato";
        font-style: normal;
        font-weight: 300;
        font-size: 14px;
        line-height: 125%;
        color: #161615;
      }
    }

    .action {
      flex: 0 0 54px;
    }
  }
  &.negative {
    .f-hint-content {
      .icon {
        color: var(--statusNegative);
      }
    }
  }

  &.notice {
    .f-hint-content {
      .icon {
        color: var(--statusNotice);
      }
    }
  }
}

.dark-mode {
  .f-hint {
 
    .f-hint-content {
      .icon {
        color: var(--primary);
		width:auto;
		font-size:20px;
      }

      .f-hint-content-content {
        .title {
          color: var(--white-a50);
        }

        .text {
          color: var(--white-a50);
        }
      }
    }
    &.negative {
		background-color:var(--white-a10);
		
      .f-hint-content {
        .icon {
          color: var(--negative);
        }
		 .f-hint-content-content
		 {
			.title {
				color:var(--white-a75);
			}
			.text {
				color:var(--white-a75);
			}
			
			a {
			color:var(--navigation);
			}
		}
      }
	  	  
    }

    &.notice {
      .f-hint-content {
        .icon {
          color: var(--statusNotice);
        }
      }
    }
  }
}
</style>